const nostoATC = ():void => {
  const selects = document.querySelectorAll('[data-nosto-select]')

  selects.forEach(select => {
    select.addEventListener('change', e => {
      const target = e.target as HTMLSelectElement
      const val = target.value
      const selector = target.dataset.nostoSelect
      const btn = document.querySelector(`[nosto-upsell-btn="${selector}"]`)
      btn.setAttribute('onclick', `window.blubolt.cart.addToCart([{id: ${val}, quantity: 1 }])`)
    })
  });
}

export default nostoATC